import styled from "styled-components";

const Input = styled.input`
width :100%;
border:none;
border-radius:0;
`;
export default Input;